export class PlanAdditionalPDFDetails {
  planId: number;
  additionalPDFClassificationId: number;
  additionalPDFClassificationName: string;
  additionalPDFClassificationFullName: string;
}
